/**
 * The words the framework's storefront extensions print ("Size chart",
 * "SKU", …): the site's `aldoo-store` TextBundle when it has the key, else
 * the defaults below in the page's language, else English.
 *
 *   const text = useStoreExtensionText()
 *   text("size_chart")   // "Таблица с размери" on a Bulgarian page
 */
import TextBundle from "aldoo-ra/CMS/text-bundle"
import Localization from "aldoo-ra/Localization"

const DEFAULTS = {
  en: {
    size_chart: "Size chart",
    sku: "SKU",
    ean: "EAN",
    related_products: "Related products",
    cross_sell_products: "Goes well with",
    total_price: "Total price",
    view_product: "View product",
    add_part: "Add",
    choose: "Please choose",
  },
  bg: {
    size_chart: "Таблица с размери",
    sku: "Код",
    ean: "EAN",
    related_products: "Свързани продукти",
    cross_sell_products: "Подходящо с",
    total_price: "Обща цена",
    view_product: "Виж продукта",
    add_part: "Добави",
    choose: "Изберете",
  },
}

/**
 * `(key) => text` for the page's language. `language` overrides it when the
 * caller knows it better (a project's url-prefixed pages, rendered on the
 * server before the localization has its language).
 */
export function useStoreExtensionText(language) {
  const bundle = TextBundle({ id: "aldoo-store" })
  const { currentLanguage } = Localization()
  const lang = language || currentLanguage
  return (key) => bundle?.[key] || DEFAULTS[lang]?.[key] || DEFAULTS.en[key] || key
}
